class shippingProgressbar {
	constructor(shippingProgressbarEl) {
		this.currentElement = shippingProgressbarEl;
		if (!this.currentElement) return;

		this.threshold = this.currentElement.dataset.threshold;
		this.freeShipping = this.currentElement.dataset.freeShipping;
		this.init();
	}

	async init() {
		this.onCartAction();
	}

	async onCartAction() {
		window.addEventListener('rendered-cart', () => {
			setTimeout(async () => {
				try {
					const cart = await fetch(window.Shopify.routes.root + 'cart.js', {
						method: 'GET',
						headers: {
							'Content-Type': 'application/json'
						}
					})

					const cartData = await cart.json();

					this.shippingCalculator(cartData);

				} catch (e) {
					console.warn('error:', e);
				}

			}, 100);
		});
	}

	shippingCalculator(cartData) {
		const cartItemsPrice = parseFloat(cartData.items_subtotal_price);
		const thresholdNumber = parseFloat(this.threshold);
		let differenceAmount = 0;
		const difference = (cartItemsPrice / thresholdNumber);
		let differencePercentage = (difference) * 100;
		if (differencePercentage >= 100) {
			differencePercentage = 100;
			this.freeShipping = true;
		} else {
			differencePercentage = differencePercentage.toFixed(2);
			this.freeShipping = false;
			differenceAmount = (thresholdNumber - cartItemsPrice) / 100;
			const differenceAmountEl = document.querySelector('.free-shipping-un__text-block span[free-shipping-difference]');
			differenceAmountEl.innerText = differenceAmount;
		}

		const sidebarCart = document.querySelector('#sidebar-cart');
		if (!sidebarCart) return;
		this.currentElement.setAttribute('data-free-shipping', this.freeShipping);
		sidebarCart.style.setProperty('--progress_difference', differencePercentage + '%');
	}

}

const shippingProgressbarEl = document.querySelector('shipping-progressbar');
if (shippingProgressbarEl) {
	new shippingProgressbar(shippingProgressbarEl);
}
